"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.FullScreenModal = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _react2 = require("@floating-ui/react");
var _useMountTransition = _interopRequireDefault(require("../../hooks/useMountTransition"));
var _motion = require("../../styles/variables/_motion");
var _opacity = require("../../styles/variables/_opacity");
var _space = require("../../styles/variables/_space");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _helpers = require("../../utils/helpers");
var _Button = require("../Button/Button");
var _Truncate = require("../Truncate/Truncate");
var _ModalModule = _interopRequireDefault(require("./Modal.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // $FlowFixMe[untyped-import]
const DEFAULT_MODAL_ANIMATION = {
  duration: {
    open: parseInt(_motion.motionDurationSlow),
    close: parseInt(_motion.motionDurationNormal)
  },
  initial: {
    transform: `translate(${_space.spaceNegHalfFluid}, ${_space.spaceNegHalfFluid}) scale(0.95)`,
    opacity: _opacity.opacity0
  },
  open: {
    transform: `translate(${_space.spaceNegHalfFluid}, ${_space.spaceNegHalfFluid}) scale(1)`,
    opacity: _opacity.opacity100
  },
  close: {
    transform: `translate(${_space.spaceNegHalfFluid}, ${_space.spaceNegHalfFluid}) scale(0.95)`,
    opacity: _opacity.opacity0
  }
};
const ModalHeader = _ref => {
  let {
    children,
    hideCloseBtn,
    onCloseButtonClick,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.count(children) > 0 && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ModalModule.default.modalHeader, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: _ModalModule.default.headerContent
  }, /*#__PURE__*/React.createElement(_Truncate.Truncate, null, children)), !hideCloseBtn && /*#__PURE__*/React.createElement(_Button.Button, {
    iconLeftName: "xmark",
    type: "ghost",
    onClick: onCloseButtonClick,
    ariaLabel: "Close Button"
  })));
};
exports.ModalHeader = ModalHeader;
const ModalBody = _ref2 => {
  let {
    children,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ModalModule.default.modalBody, className)
  }, children);
};
exports.ModalBody = ModalBody;
const ModalFooter = _ref3 => {
  let {
    children,
    classNames
  } = _ref3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.count(children) > 0 && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ModalModule.default.modalFooter, classNames?.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ModalModule.default.modalFooterActions, classNames?.actions)
  }, children)));
};
exports.ModalFooter = ModalFooter;
const createPortalRoot = id => {
  const modalRoot = document.createElement('div');
  modalRoot.setAttribute('id', `modal-root-${id}`);
  return modalRoot;
};
const getModalRoot = id => document.getElementById(`modal-root-${id}`);
function hasChildNode(nodeList) {
  for (let i = 0, len = nodeList.length; i < len; i++) {
    if (nodeList[i].firstChild !== null) {
      return true;
    }
  }
  return false;
}
const fixBody = bodyEl => {
  const body = document.getElementsByTagName('body')[0];
  if (body && body.classList) {
    body.classList.add('fixed');
  }
  if (bodyEl) {
    bodyEl.style.overflow = 'hidden';
  }
};
const unfixBody = bodyEl => {
  const body = document.getElementsByTagName('body')[0];
  if (body && body.classList) {
    body.classList.remove('fixed');
  }
  if (bodyEl) {
    bodyEl.style.overflow = '';
  }
};
const checkAndAddBodyOverflow = bodyEl => {
  const nodes = document.querySelectorAll('[id^="modal-root"]');
  let isParentModalPresent = false;
  if (nodes.length) {
    isParentModalPresent = hasChildNode(nodes);
  }
  if (isParentModalPresent) {
    fixBody(bodyEl);
  } else {
    unfixBody(bodyEl);
  }
};
const Modal = _ref4 => {
  let {
    classNames,
    children,
    isOpen = false,
    onClose,
    hideBackdrop = false,
    tapOutsideToClose = true,
    initialFocus = -1,
    customAnimation,
    allowBackgroundInteraction = false,
    // Size is not set to default for backward compatibility. Don't change if you don't know this.
    size
  } = _ref4;
  const {
    refs,
    context
  } = (0, _react2.useFloating)({
    open: isOpen
  });
  const {
    isMounted,
    styles
  } = (0, _react2.useTransitionStyles)(context, customAnimation || DEFAULT_MODAL_ANIMATION);
  const modalId = (0, _helpers.uuid)();
  const bodyRef = React.useRef(document.querySelector('body'));
  const portalRootRef = React.useRef(getModalRoot(modalId) || createPortalRoot(modalId));
  const isTransitioning = (0, _useMountTransition.default)(isOpen, parseInt(_motion.motionDurationNormal));

  // Append portal root on mount
  React.useEffect(() => {
    bodyRef.current?.appendChild(portalRootRef.current);
    const portal = portalRootRef.current;
    const bodyEl = bodyRef.current;
    return () => {
      // Clean up the portal when modal component unmounts
      portal.remove();
      // Ensure scroll overflow is removed
      if (bodyEl) {
        unfixBody(bodyEl);
      }
    };
  }, []);

  // Prevent page scrolling when the modal is open
  React.useEffect(() => {
    const updatePageScroll = () => {
      if (isOpen) {
        if (bodyRef.current) {
          fixBody(bodyRef.current);
        }
      } else {
        if (bodyRef.current) {
          unfixBody(bodyRef.current);
        }
      }
    };
    updatePageScroll();
  }, [isOpen]);

  // Allow Escape key to dismiss the modal
  React.useEffect(() => {
    const onKeyPress = e => {
      if (e.key === 'Escape') {
        tapOutsideToClose && onClose && onClose(e);
      }
    };
    if (isOpen) {
      window.addEventListener('keyup', onKeyPress);
    }
    return () => {
      window.removeEventListener('keyup', onKeyPress);
    };
  }, [isOpen, onClose]);
  if (!isOpen && !isMounted) {
    // Check overflow after resetting the DOM for modal. This should always happen after DOM reset
    // TODO(Nishant): Better way to do this?
    setTimeout(() => {
      if (bodyRef && !!bodyRef.current) {
        checkAndAddBodyOverflow(bodyRef.current);
      }
    });
    return null;
  }
  const onBackdropClick = e => {
    if (tapOutsideToClose && onClose) {
      onClose(e);
    }
  };
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/React.createElement(_react2.FloatingFocusManager, {
    context: context,
    initialFocus: initialFocus
  }, /*#__PURE__*/React.createElement("div", {
    ref: refs.setFloating,
    "aria-hidden": isOpen ? 'false' : 'true',
    className: (0, _classify.default)(_ModalModule.default.modalContainer, {
      [_ModalModule.default.in]: isTransitioning,
      [_ModalModule.default.open]: isOpen
    }, classNames?.container)
  }, !allowBackgroundInteraction && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ModalModule.default.backdrop, {
      [_ModalModule.default.darkBackdrop]: !hideBackdrop
    }, classNames?.backdrop),
    onClick: onBackdropClick,
    style: {
      opacity: styles?.opacity,
      transition: styles?.transition
    }
  }), isMounted && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ModalModule.default.modal, {
      [_ModalModule.default.small]: size === 'small',
      [_ModalModule.default.medium]: size === 'medium',
      [_ModalModule.default.large]: size === 'large'
    }, classNames?.content),
    role: "dialog",
    style: {
      // Transition styles
      ...styles
    }
  }, children))), portalRootRef.current);
};

// FullScreen modal that just calls the Modal component with a wrapper className set which sets the width and height to sizeFluid
exports.Modal = Modal;
const FullScreenModal = _ref5 => {
  let {
    classNames,
    ...props
  } = _ref5;
  return /*#__PURE__*/React.createElement(Modal, _extends({
    classNames: {
      ...classNames,
      content: (0, _classify.default)(_ModalModule.default.fullscreenModalContainer, classNames?.content)
    }
  }, props));
};
exports.FullScreenModal = FullScreenModal;